// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2ProcessingResultModel {
    static getAttributeTypeMap() {
        return EnrollmentV2ProcessingResultModel.attributeTypeMap;
    }
}
EnrollmentV2ProcessingResultModel.discriminator = undefined;
EnrollmentV2ProcessingResultModel.attributeTypeMap = [
    {
        "name": "enrollment",
        "baseName": "enrollment",
        "type": "EnrollmentV2EnrollmentModel"
    },
    {
        "name": "updateCaseId",
        "baseName": "updateCaseId",
        "type": "number"
    },
    {
        "name": "memberNumbersResult",
        "baseName": "memberNumbersResult",
        "type": "Array<EnrollmentV2RulesAssignMemberNumberResultModel>"
    },
    {
        "name": "relatedAccumulatorId",
        "baseName": "relatedAccumulatorId",
        "type": "number"
    },
    {
        "name": "evaluationResult",
        "baseName": "evaluationResult",
        "type": "EnrollmentV2ProcessingOutcomeModel"
    },
    {
        "name": "benefitResult",
        "baseName": "benefitResult",
        "type": "EnrollmentV2ProcessingBenefitModel"
    },
    {
        "name": "metaRuleResults",
        "baseName": "metaRuleResults",
        "type": "Array<EnrollmentServiceV2PublicModelsRulesMetaRuleResultModel>"
    },
    {
        "name": "memberNumberBucketResults",
        "baseName": "memberNumberBucketResults",
        "type": "Array<EnrollmentV2RulesMemberNumberBucketResult>"
    }
];
//# sourceMappingURL=enrollmentV2ProcessingResultModel.js.map